module.exports = __webpack_public_path__ + "img/pdf-white.265f1100.svg";